
/* eslint-disable */
import styles from './style.module.scss';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import { t } from '@web-solutions/module-localization';
import { useNav } from 'src/onboarding/hooks/nav';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import Analytics from '@web-solutions/module-analytics';

function Page() {
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={styles.page}>
      {currentIndex !== 0 && (
        <div className={styles.back} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={styles.wrapperInfo}>
        <Title className={styles.title}>{t('onboarding.fastingTransition.title')}</Title>

        <Text semibold className={styles.description}>
          {t('onboarding.fastingTransition.text')}
        </Text>

        <Text semibold className={styles.description} style={{marginTop: '20px'}}>
          {t('onboarding.fastingTransition.text2')}
        </Text>
      </div>

      <div className={styles.continue}>
        <div className={styles.blur}></div>
        <Button
          onClick={() => {
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'fasting-transition',
            });
            onNext();
          }}
          title={t('onboarding.fastingTransition.continue')}
        />
      </div>
    </div>
  );
}

export default Page;
